import { OrganizationSettingsData } from "../../models/organizationSettingsData";
import { OrganizationDiscount } from "../../models/organizationSettingsData";

export interface OrganizationSettingsState {
  organizationSettings: OrganizationSettingsData;
  isLoading: boolean;
  isLoaded: boolean;
  error: string | null;
}

export const FETCH_ORGANIZATION_SETTINGS_REQUEST = "FETCH_ORGANIZATION_SETTINGS_REQUEST";
export const FETCH_ORGANIZATION_SETTINGS_SUCCESS = "FETCH_ORGANIZATION_SETTINGS_SUCCESS";
export const FETCH_ORGANIZATION_SETTINGS_FAILURE = "FETCH_ORGANIZATION_SETTINGS_FAILURE";

export const SET_ORGANIZATION_SETTINGS_REQUEST = "SET_ORGANIZATION_SETTINGS_REQUEST";
export const SET_ORGANIZATION_SETTINGS_SUCCESS = "SET_ORGANIZATION_SETTINGS_SUCCESS";
export const SET_ORGANIZATION_SETTINGS_FAILURE = "SET_ORGANIZATION_SETTINGS_FAILURE";

export const SET_LOCAL_DISCOUNTS = "SET_LOCAL_DISCOUNTS";

/**
 * Action type dispatched when organization settings request starts.
 */
export interface FetchOrganizationSettingsRequestAction {
  type: typeof FETCH_ORGANIZATION_SETTINGS_REQUEST;
}

/**
 * Action type dispatched when organization settings are successfully fetched.
 */
export interface FetchOrganizationSettingsFailureAction {
  type: typeof FETCH_ORGANIZATION_SETTINGS_FAILURE;
  error: string;
}

/**
 * Action type dispatched when there is an error fetching organization settings.
 */
export interface FetchOrganizationSettingsSuccessAction {
  type: typeof FETCH_ORGANIZATION_SETTINGS_SUCCESS;
  data: OrganizationSettingsData;
}

/**
 * Action type dispatched when organization settings are successfully set.
 */
export interface SetOrganizationSettingsSuccessAction {
  type: typeof SET_ORGANIZATION_SETTINGS_SUCCESS;
  data: OrganizationSettingsData;
}

/**
 * Action type dispatched when there is an error setting organization settings.
 */
export interface SetOrganizationSettingsFailureAction {
  type: typeof SET_ORGANIZATION_SETTINGS_FAILURE;
  error: string;
}

/**
 * Action type dispatched when organization settings request starts.
 */
export interface SetOrganizationSettingsRequestAction {
  type: typeof SET_ORGANIZATION_SETTINGS_REQUEST;
}

/**
 * Action type dispatched to set local discounts.
 */
export interface SetLocalDiscountsAction {
  type: typeof SET_LOCAL_DISCOUNTS;
  discounts: OrganizationDiscount[];
}

/**
 * Union type for all the action types related to organization settings.
 */
export type OrganizationSettingsActionTypes =
  | FetchOrganizationSettingsRequestAction
  | FetchOrganizationSettingsFailureAction
  | FetchOrganizationSettingsSuccessAction
  | SetOrganizationSettingsRequestAction
  | SetOrganizationSettingsSuccessAction
  | SetOrganizationSettingsFailureAction
  | SetLocalDiscountsAction;
